import React from 'react';
import '../less/strategy.less';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock/views/Advantages';
import feature_img_1 from '../img/feature_img_1.png';
import feature_img_2 from '../img/feature_img_2.png';
import feature_img_3 from '../img/feature_img_3.png';
import feature_img_4 from '../img/feature_img_4.png';
import { getSafeLinkProps } from '../../../helpers/utils/urlSecurity';


export default function template() {
    const advantagesItems = [
        {
            img: feature_img_1,
            title: 'ABOUT_STRATEGY_TARGET_HEADING_1',
            text: 'ABOUT_STRATEGY_TARGET_1',
            type: 5
        },
        {
            img: feature_img_2,
            title: 'ABOUT_STRATEGY_TARGET_HEADING_2',
            text: 'ABOUT_STRATEGY_TARGET_2',
            type: 5
        },
        {
            img: feature_img_3,
            title: 'ABOUT_STRATEGY_TARGET_HEADING_3',
            text: 'ABOUT_STRATEGY_TARGET_3',
            type: 5
        },
        {
            img: feature_img_4,
            title: 'ABOUT_STRATEGY_TARGET_HEADING_4',
            text: 'ABOUT_STRATEGY_TARGET_4',
            type: 5
        }
    ];

    return (
        <div className="module-about-strategy">
            <Advantages items={advantagesItems} title={'HEADER_LINK_STRATEGY'} />
            <div className="strategy-button-wrapper">
              <a className="strategy-button" {...getSafeLinkProps('/static/about/strategy.pdf')}>{this.l10n('ABOUT_STRATEGY_HEADING_STRATEGY')}</a>
            </div>
        </div>
    );
}
